import type { AbstractControl, FormControl, ValidationErrors } from '@angular/forms';

import { NEGATIVE_POSITIVE_NUMBER_WITH_SEPARATORS_PATTERN } from '../regex-patterns';

export const salaryValidator = (control: FormControl): ValidationErrors | null => {
  if (!control) return null;

  if (isEmpty(control)) return null;
  if (!isNumber(control)) return { notNumber: true };
  if (!isGreaterThanOrEqualToZero(control)) return { notGreaterThanOrEqualToZero: true };
  return null;
};

const isEmpty = (control: AbstractControl) => control && !control.value && control.value !== 0;

const isNumber = (control: AbstractControl) =>
  NEGATIVE_POSITIVE_NUMBER_WITH_SEPARATORS_PATTERN.test(
    formatNumberWithSeparators(control.value.toString()),
  );

const isGreaterThanOrEqualToZero = (control: AbstractControl) =>
  Number(formatNumberWithSeparators(control.value.toString())) >= 0;

const formatNumberWithSeparators = (value: string): string =>
  value
    .replace(',', '.')
    .replace(/[.](?=.*[.])/g, '')
    .replace(/\s/g, '');
